// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__Xzn1N","link":"Footer_link__271pA"};